import { ContactSupport } from '@core/typings/ui/support.typing';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';


@RegisterYCState()
export class SupportState extends BaseYcState {
  readonly prepopData: ContactSupport.ContactSupportModalReturn;
}
